import React from 'react';

export const PartnershipOverviewPlaceholderComponent = () => {
	return(
	    <div className="col-xs-12 col-sm-6 col-lg-4 partnersPlaceholder-item">
            <div className="item-body">
                <div className="partnersPlaceholder-item__header">{/* todo: Remove when styled, add secondaryColour*/}
                    <div className="partnersPlaceholder-logo">
                    </div>
                </div>
                <div className="partnersPlaceholder-item__title">
                    <div className="titleAnimation"/>
                </div>
                <div className="partnersPlaceholder-item__details">
                    <div className="detailsAnimation"/>
                    <div className="detailsAnimation"/>
                    <div className="detailsAnimation"/>
                </div>
                <div className="partnersPlaceholder-item__buttons pos-bottom">
                    <div className="buttonAnimation"/>
                </div>
            </div>
        </div>

	);
};


// WEBPACK FOOTER //
// src/client/components/common/placeholders/PartnershipOverviewPlaceholderComponent.js